import apiClient from './apiClient';

const fetchEmails = async () => {
  try {
    const response = await apiClient.get('/email-templates');
    return response.data;
  } catch (error) {
    console.error('Error fetching emails:', error);
    throw error;
  }
};

export const deleteEmail = async (emailId) => {
  try {
    await apiClient.delete(`/email-templates/${emailId}`);
  } catch (error) {
    throw new Error(`Failed to delete email with ID ${emailId}: ${error.message}`);
  }
};

export { fetchEmails };
